import Axios from "../../configs/axios.config";

export const createHelpCenterQuestion = (data) => Axios.post(`/help-center/questions`, data).then(response=>response.data.data);
export const updateHelpCenterQuestion = (data, id) => Axios.put(`/help-center/questions/${id}`, data).then(response=>response.data.data);
export const getHelpCenterQuestionList = (data) => Axios.get('/help-center/questions', { params: data }).then(response=>response.data.data);
export const getHelpCenterQuestionDetail = (id) => Axios.get(`/help-center/questions/${id}`).then(response=>response.data.data);
export const deleteHelpCenterQuestion = (id) => Axios.delete(`/help-center/questions/${id}`);
